(function (angular) {
  "use strict";

  angular.module("app").controller("faqController", faqController);

  faqController.$inject = ["alerts", "$http", "thisUser", "thisSiteSettings"];

  function faqController(alerts, $http, thisUser, thisSiteSettings) {
    var vm = this;

    // properties
    vm.loading = false;
    vm.errors = {};
    vm.form = {}; // form data.
    vm.botForm = {}; // bot form data.
    vm.selectedQuestion = ""; // Holds the selected question from the dropdown
    vm.defaultQuestions = thisSiteSettings.faq_default_questions || []; // Initialize with default questions

    // methods
    vm.updateQuestion = updateQuestion;

    function updateQuestion() {
      vm.form.question = vm.selectedQuestion;
    }

    if (thisUser) {
      vm.form = {
        name: thisUser.full_name,
        email: thisUser.email,
        question: "",
      };
    }

    // methods
    vm.submit = submit;

    /**
     * Sign up a new user.
     *
     * @return {void}
     */
    function submit() {
      vm.errors = {};

      if (vm.botForm.name || vm.botForm.email || vm.botForm.question) {
        alerts.emit({
          theme: "error",
          title: "Bot form input filled in",
          messages: [],
        });
      } else if (vm.faqForm.$valid) {
        vm.loading = true;

        vm.form.gRecaptchaResponse = angular
          .element("#g-recaptcha-response")
          .val();

        $http.post("/faq", vm.form).then(
          function successCallback() {
            vm.loading = false;
            vm.form = {};
            alerts.emit({
              theme: "success",
              title: "Thanks, we'll be in touch shortly.",
              messages: [],
            });
          },
          function errorCallback() {
            vm.loading = false;
          },
        );
      }
    }
  }
})(angular);
